var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('TheAppBar',{attrs:{"refetch":_vm.refetch},on:{"hamburger-toggle":_vm.toggleDrawer}}),_c('TheNavigationDrawer',{ref:"drawer",attrs:{"id":"navigation-drawer"}}),_c('v-main',{staticClass:"main-base",on:{"avatar-updated":_vm.avatarUpdated}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }